<template>
  <div>
    <v-toolbar
      class="action-icons-bar"
      height="67px"
      :style="{
        'background-color': getWebchat().campaign.color,
      }"
    >
      <v-toolbar-title>
        <v-btn
          icon
          v-if="getWebchat().isLowRes"
          @click.native="minimizeWindow"
          class="left-arrow-back"
        >
          <v-icon
            x-large
            style="margin-top: 12px"
            :style="{
              color: invertColor(getWebchat().campaign.color),
            }"
            >mdi-chevron-left</v-icon
          >
        </v-btn>
        <div
          class="avatar-agent-pic"
          :class="{
            isLowRes: getWebchat().isLowRes,
          }"
          v-if="
            getWebchat().campaign.show_agent &&
            !getWebchat().interaction.transfering
          "
          :style="{
            'background-image':
              'url(' +
              getWebchat().menu.menu_img +
              '?' +
              new Date().getTime() +
              ')',
          }"
        ></div>
        <div
          class="avatar-agent-pic"
          :class="{
            isLowRes: getWebchat().isLowRes,
          }"
          v-else-if="
            !getWebchat().campaign.show_agent &&
            !getWebchat().interaction.transfering &&
            getWebchat().campaign.logo
          "
          :style="{
            'background-image': 'url(' + getWebchat().campaign.logoName + ')',
          }"
        ></div>
        <div
          class="avatar-agent-pic"
          :class="{
            isLowRes: getWebchat().isLowRes,
          }"
          v-else-if="!getWebchat().interaction.transfering"
          :style="{ 'background-image': 'url(' + avatar + ')' }"
        ></div>

        <div
          class="avatar-agent-pic"
          :class="{
            isLowRes: getWebchat().isLowRes,
          }"
          v-else-if="getWebchat().interaction.transfering"
        >
          <v-icon
            :style="{
              color: invertColor(getWebchat().campaign.color),
            }"
            style="font-size: 50px !important"
            class="spinIcon"
          >
            mdi-autorenew
          </v-icon>
        </div>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
          <span        
            class="agent-name"
            :class="{
              isLowRes: getWebchat().isLowRes,
            }"
            v-if="getWebchat().campaign.show_agent &&
              !getWebchat().interaction.transfering
              "
            :style="{
              color: invertColor(getWebchat().campaign.color),
            }"            
            v-on="on"                   
            >{{ getWebchat().interaction.agent }}
                      
          </span>
          <span
            class="agent-name"
            :class="{
              isLowRes: getWebchat().isLowRes,
            }"
            v-else-if="!getWebchat().campaign.show_agent &&
              !getWebchat().interaction.transfering
              "
            :style="{
              color: invertColor(getWebchat().campaign.color),
            }"              
            v-on="on"          
            >CHAT
          </span>      
      
          <span
            class="agent-name"
            :class="{
              isLowRes: getWebchat().isLowRes,
            }"  
            v-else-if="getWebchat().interaction.transfering"
            :style="{
              color: invertColor(getWebchat().campaign.color),
            }"                        
            v-on="on"          
            >{{ $t("transfering") }}
          </span>


        <p
          v-if="!getWebchat().interaction.transfering"
          class="response-time"
          :class="{
            isLowRes: getWebchat().isLowRes,
          }"
          :style="{
            color: invertColor(getWebchat().campaign.color),
          }"            
            v-on="on"  
        >
          {{ $t("available") }}
        </p>      
      </template>
      <span v-if="getWebchat().campaign.show_agent &&
              !getWebchat().interaction.transfering
              "> {{ getWebchat().interaction.agent }}</span>
      <span v-else-if="!getWebchat().campaign.show_agent &&
              !getWebchat().interaction.transfering
              ">CHAT</span>
      <span v-else-if="getWebchat().interaction.transfering">{{ $t("transfering") }}</span> 
      </v-tooltip>  

      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-if="!getWebchat().isLowRes">
        <v-tooltip
          bottom
          v-for="(button, index) in buttons.filter((b) => b.show())"
          :key="index"
        >
          <template #activator="{ on }">
            <v-btn
              v-on="on"
              icon
              :id="button.id"
              :disabled="button.disabled()"
              @click.stop.prevent="button.action"
            >
              <v-icon
                :style="{
                  color: invertColor(getWebchat().campaign.color),
                }"
              >
                mdi-{{ button.icon }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t(button.text) }}</span>
    </v-tooltip>

      </v-toolbar-items>
      <v-toolbar-items v-else>
        <v-menu z-index="1000000">
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              v-for="(button, index) in buttons.filter((b) => b.show())"
              :key="index"
              :id="button.id"
              @click="button.action"
              :disabled="button.disabled()"
            >
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-{{ button.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t(button.text) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
import DetectRTC from "detectrtc";
import Avatar from "../assets/avatar.png";
import { invertColor } from "@/assets/utils";

export default {
  name: "chat-toolbar",
  props: { hideEndConv: Boolean, isBot: Boolean },
  data() {
    return {
      avatar: Avatar,
      hasWebRTC: false,
      window: window,
      buttons: [
        {
          text: "videocall",
          icon: "video",
          action: this.videoCall,
          id: "btn-videocall",
          disabled: () => {
            return this.isInCall;
          },
          show: () => {
            return this.allowedCalls && this.hasWebRTC && !this.hideButtons;
          },
        },
        {
          text: "call",
          icon: "phone",
          action: this.makeCall,
          id: "btn-call",
          disabled: () => {
            return this.isInCall;
          },
          show: () => {
            return this.allowedCalls && this.hasWebRTC && !this.hideButtons;
          },
        },
        {
          text: "accessibility",
          icon: "human",
          action: this.openAccessibilityModal,
          id: "btn-accessibility",
          disabled: () => {
            return false;
          },
          show: () => {
            return true;
          },
        },
        {
          text: "endchat",
          icon: "close",
          action: this.openCloseModal,
          id: "btn-endchat",
          disabled: () => {
            return false;
          },
          show: () => {
            return !this.hideEndConv;
          },
        },
      ],
    };
  },
  computed: {
    getVisiblePhoneIcons() {
      return this.hasWebRTC;
    },
    isInCall() {
      return this.$store.state[
        this.$store.state.findIndex(
          (e) => e.configuration.campaign === this.$route.query.campaign
        )
      ].isInCall;
    },

    isIOS() {
      const campaignName = this.$route.query.campaign;

      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      return this.$store.state[index].isIOS;
    },

    isMobile() {
      const campaignName = this.$route.query.campaign;

      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      return this.$store.state[index].isMobile;
    },

    allowedCalls() {
      const campaignName = this.$route.query.campaign;

      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      return this.$store.state[index].campaign.allow_call;
    },

    hideButtons() {
      return this.hideEndConv || this.isBot;
    },
  },

  created() {
    DetectRTC.load(() => {
      this.hasWebRTC = DetectRTC.isWebRTCSupported;
    });
  },

  methods: {
    isChrome() {
      return navigator.userAgent.indexOf("CriOS") > -1;
    },
    makeCall() {
      this.$emit("clickCallEv");
    },

    videoCall() {
      this.$emit("clickVideoCallEv");
    },

    openCloseModal() {
      this.$emit("openConfirmationModal");
    },

    openAccessibilityModal() {
      this.$emit("openAccessibilityModal");
    },

    getWebchat() {
      return this.$store.state[
        this.$store.state.findIndex(
          (e) => e.configuration.campaign === this.$route.query.campaign
        )
      ];
    },

    /**
     * @name MINIMIZE_WINDOW
     * @desc Broadcast event to entrypoint to minimize the chat
     */
    minimizeWindow() {
      window.parent.postMessage({ action: "MINIMIZE" }, "*");
    },

    invertColor,
  },
};
</script>

<style>
.action-icons-bar > .v-toolbar__content > .v-toolbar__title {
  width: 212px;
}
</style>

<style scoped>
.rounded-borders {
  border-radius: 6px 6px 0 0 !important;
}

.response-time {
  width: 142px;
  font-size: 11px;
  position: relative;
  color: #ffffffb5;
  left: 60px;
  opacity: 0.7;
  top: 17px;
  letter-spacing: -0.3px;
  white-space: pre-wrap;
  overflow: initial;
  text-overflow: ellipsis;
}

.response-time.isLowRes {
  left: 85px;
}

.action-icons-bar {
  z-index: 5;
  background-size: 100%;
  cursor: pointer;
}

.action-icons-bar::after {
  content: "";
  background: linear-gradient(
    135deg,
    rgba(35, 146, 236, 0),
    rgba(0, 0, 0, 0.29)
  );
  background-blend-mode: overlay;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: -1;
}

.chatbar-button {
  width: 36px !important;
  height: 36px !important;
  margin-top: 12px !important;
  margin-right: 8px !important;
}

.action-icons-bar .v-toolbar__content .v-toolbar__items {
  position: relative;
  right: -10px;
}

.avatar-agent-pic {
  width: 47px;
  height: 47px;
  background-size: 106% 106%;
  border-radius: 50%;
  background-position: -1px 0px;
  position: absolute;
  left: 14px;
  top: 14px;
}

.avatar-agent-pic.isLowRes {
  position: absolute !important;
  left: 42px;
}

.agent-name {
  position: absolute;
  left: 77px;
  top: 10px;
  letter-spacing: -0.2px;
  width: clamp(92px, calc(100% - 263px), 100%);
  font-size: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agent-name.isLowRes {
  position: absolute !important;
  left: 100px;
}

.left-arrow-back {
  position: absolute !important;
  left: -2px;
  bottom: 14px;
}

#btn-videocall:disabled *,
#btn-call:disabled * {
  color: rgb(90, 90, 90) !important;
}

.spinIcon {
  animation-name: spin;
  animation-duration: 3000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
